import React from 'react';
import { useWrapRequest } from '@components/hooks/use-wrap-request';
import { Api } from '@core/api';
import { injectTSDI } from '@core/tsdi';

export function usePointDefinitionsStore(communityId: number) {
    const { fitnessActivityClient } = injectTSDI(Api);

    const definitions = useWrapRequest(
        async () => {
            const result = await fitnessActivityClient.admin
                .compositePointDefinitionControllerGetByCommunityId({
                    communityId
                });
            const data = result.data ?? [];
            return {
                content: data,
                number: 0,
                size: data.length,
                totalElements: data.length
            };
        },
        {
            defaultData: {
                content: [],
                number: 0,
                size: 0,
                totalElements: 0
            }
        }
    );

    React.useEffect(() => {
        definitions.request([]);
    }, [communityId]);

    const refresh = () => {
        definitions.request([]);
    };

    return { definitions, refresh };
}
